/**
 * HeadersAndSections.js
 * Created by calhosh on 2/26/2021.
 */
import React from 'react';
import HeaderAndSectionItem from '../../Common/Rail/HeaderAndSectionItem';

export default function HeadersAndSections(props) {
	const {
		formData,
		signOffs,
		filteredRailData,
		currentHeaderId,
		onClickHandle,
		isExpanded,
		clearComments,
		currentSectionId,
		showValidationsIcon
	} = props;

	return (
		<ul className="canvasFormLeftNavSliderList">
			{filteredRailData.map((railData) => {
				let secondLevelDisplayedData =
					railData &&
					railData.secondLevel &&
					railData.secondLevel.length > 0 &&
					railData.secondLevel.filter((secondLevel) => secondLevel.isDisplayed || secondLevel.isCustom);
				return (
					<HeaderAndSectionItem
						key={railData.id}
						railData={railData}
						secondLevelDisplayedData={secondLevelDisplayedData}
						currentHeaderId={currentHeaderId}
						onClickHandle={onClickHandle}
						signOffs={signOffs}
						formData={formData}
						isExpanded={isExpanded}
						clearComments={clearComments}
						currentSectionId={currentSectionId}
						showValidationsIcon={showValidationsIcon}
					/>
				);
			})}
		</ul>
	);
}
